<template>
  <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu
        v-bind:organization="organization"
        data-tour="nav_user"
      ></user-menu>
      <div class="sidebar-divider"></div>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"
          data-tour="nav_dashboard"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Sessions', icon: 'show_chart', path: '/sessionInfo' }"
          data-tour="nav_sessions"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Applications', icon: 'web', path: '/applications' }"
          data-tour="nav_applications"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'API Keys', icon: 'vpn_key', path: '/apikeys' }"
          data-tour="nav_apikeys"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Subscription',
            icon: 'shopping_cart',
            path: '/subscription'
          }"
          data-tour="nav_subscription"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Downloads',
            icon: 'cloud_download',
            path: '/downloads'
          }"
          data-tour="nav_downloads"
        >
        </sidebar-item>
        <div id="recording_sidebar_container">
          <sidebar-item
            :link="{
              name: 'Recordings',
              icon: 'videocam',
              path: '/recordings'
            }"
          >
          </sidebar-item>
          <span class="material-icons overusage_icon" v-if="overusage">error<div/></span>
        </div>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar v-bind:organization="organization"></top-navbar>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <chargebee-checkout ref="chargebee"></chargebee-checkout>
  </div>
  <!--
  Embedding mode ... needs white labelled option.
  <iframe id="hourly-connections" src="https://modeanalytics.com/frozenmountain/reports/ff430a3d263e/embed?&max_age=10&param_application_id=b31de186000d56afb3d816af07a1edb7" width="100%" height="300" frameborder="0"></iframe>
  <iframe id="daily-connections" src="https://modeanalytics.com/frozenmountain/reports/012be61aade7/embed?&max_age=10&param_application_id=b31de186000d56afb3d816af07a1edb7" width="100%" height="600" frameborder="0"></iframe>
  -->
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { get } from "vuex-pathify";
import ChargebeeCheckout from "@/fmComponents/ChargebeeCheckout";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
    ChargebeeCheckout
  },
  computed: {
    organization: get("organization/organization")
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "primary",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      show_cart: false,
      cart_items: [],
      selected_item: null,
      planId: null,
      overusage: false,
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  created() {
    var me = this;
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }

    // Subscribe to the global notification mutations.
    this.$store.subscribe(mutation => {
      switch (mutation.type) {
        case "pushInfo":
        case "pushSuccess":
        case "pushAlert":
        case "pushError":
          this.$store.dispatch("popNotification").then(function(n) {
            me.$notify(n);
          });
          break;
      }
    });

    if (localStorage.organizationId) {
      this.$store.dispatch(
        "organization/loadOrganization",
        localStorage.organizationId
      );
    }

    if (localStorage.userId) {
      this.$store.dispatch("user/loadEntity", localStorage.userId);
    }

    this.$store
      .dispatch("recording/maximumSize")
      .then(maxSize => {
        this.$store
          .dispatch("recording/totalSize")
          .then(totalSize => {
            if (totalSize > maxSize) {
              this.overusage = true;
            } else {
              this.overusage = false;
            }
          });
      });
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  },
  updated() {
    this.$refs.chargebee.landMethod();
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

/* `sidebar-divider` is a class added by me (Adam) to mimic what
  VMD did with the `logo` and `user` divs. This was necessary as
  the VMD styles were hooked into the DOM structure (not just the
  classes), but we needed to change that structure a little bit. */
.sidebar .sidebar-divider:after {
  content: "";
  display: block;
  position: relative;
  bottom: 0;
  left: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(180, 180, 180, 0.3);
}
#modal-overlay {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  text-align: center;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.7);
}
.to-free {
  font-size: 10px;
  color: red;
}
.small-text {
  font-size: 10px;
}
#recording_sidebar_container {
  position: relative;
  margin: 15px 0;
}
.overusage_icon {
  position: absolute;
  top: -20%;
  right: 5px;
}
.sidebar .md-icon.md-theme-default.md-icon-font, .sidebar .material-icons, .off-canvas-sidebar .md-icon.md-theme-default.md-icon-font, .off-canvas-sidebar .material-icons {
  color: red !important;
}
</style>
